import Button from "components/button";
import { MouseEvent } from "react";

type IProps = {
  title: string;
  formId: string;
  isCreate?: boolean;
  isButs?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export default function SearchHead({
  title,
  formId,
  isCreate,
  isButs = true,
  onClick,
}: IProps) {
  return (
    <>
      <div className="sub-head">
        <ul className="">
          <li className="flex items-center gap-2">
            <h3>{title}</h3>
          </li>
          {isButs && (
            <li>
              <div className="flex justify-end gap-col-2 mb-[4px]">
                <Button
                  formId={formId}
                  type={"submit"}
                  text={"조회"}
                  className="btn bg-navy-400"
                  size={"sm"}
                  role={"search"}
                />
                <Button
                  hidden={!isCreate}
                  formId={formId}
                  type={"button"}
                  text={"신규"}
                  size={"sm"}
                  className="btn bg-red-400"
                  onClick={onClick}
                  role={"create"}
                />
                <Button
                  formId={formId}
                  type={"reset"}
                  text={"초기화"}
                  className="btn bg-gray-400"
                  role="reset"
                  size={"sm"}
                />
              </div>
            </li>
          )}
        </ul>
      </div>
    </>
  );
}
